export default "__VITE_ASSET__BaAI_b5K__"